const classMapData = [
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 162,
    Capacity: 173,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 198,
    Capacity: 198,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 252,
    Capacity: 258,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 175,
    Capacity: 193,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 186,
    Capacity: 198,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 72,
    Capacity: 78,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 69,
    Capacity: 72,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 241,
    Capacity: 246,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 260,
    Capacity: 276,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 180,
    Capacity: 204,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 269,
    Capacity: 291,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 280,
    Capacity: 276,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 428,
    Capacity: 443,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 182,
    Capacity: 203,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 116,
    Capacity: 186,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 127,
    Capacity: 186,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 22,
    Capacity: 24,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 238,
    Capacity: 231,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 249,
    Capacity: 243,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 291,
    Capacity: 298,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 376,
    Capacity: 419,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 187,
    Capacity: 198,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 233,
    Capacity: 235,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 187,
    Capacity: 200,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 142,
    Capacity: 165,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 190,
    Capacity: 196,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 233,
    Capacity: 241,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 45,
    Capacity: 46,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 86,
    Capacity: 92,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 241,
    Capacity: 246,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 260,
    Capacity: 276,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 205,
    Capacity: 229,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 269,
    Capacity: 291,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 280,
    Capacity: 276,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 448,
    Capacity: 463,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 183,
    Capacity: 205,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 56,
    Capacity: 123,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 43,
    Capacity: 98,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 22,
    Capacity: 24,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 238,
    Capacity: 231,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 249,
    Capacity: 243,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 291,
    Capacity: 298,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 376,
    Capacity: 419,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 154,
    Capacity: 170,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 120,
    Capacity: 125,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 16,
    Capacity: 18,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 16,
    Capacity: 18,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 150,
    Capacity: 156,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 169,
    Capacity: 186,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Anthro/Art Practice Bldg',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 173,
    Capacity: 178,
    address: 'Anthropology and Art Practice Building',
    lat: 37.869853,
    lon: -122.2577267,
    center: [
      37.869853,
      -122.2577267,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 90,
    Capacity: 90,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 52,
    Capacity: 48,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 26,
    Capacity: 0,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 82,
    Capacity: 85,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 79,
    Capacity: 80,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 102,
    Capacity: 108,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 91,
    Capacity: 94,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 6,
    Capacity: 4,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 6,
    Capacity: 4,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 67,
    Capacity: 73,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 95,
    Capacity: 110,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 51,
    Capacity: 60,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 42,
    Capacity: 88,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 121,
    Capacity: 164,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 90,
    Capacity: 90,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 92,
    Capacity: 98,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 117,
    Capacity: 123,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 102,
    Capacity: 123,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 82,
    Capacity: 85,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 79,
    Capacity: 80,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 102,
    Capacity: 108,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 24,
    Capacity: 25,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 85,
    Capacity: 90,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 29,
    Capacity: 30,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 25,
    Capacity: 25,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 44,
    Capacity: 50,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 95,
    Capacity: 110,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 51,
    Capacity: 60,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 42,
    Capacity: 88,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 115,
    Capacity: 160,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 118,
    Capacity: 118,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 27,
    Capacity: 28,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 25,
    Capacity: 25,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 82,
    Capacity: 85,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 79,
    Capacity: 80,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 102,
    Capacity: 108,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Barker',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 51,
    Capacity: 65,
    address: 'Barker Hall',
    lat: 37.8739287,
    lon: -122.2680451,
    center: [
      37.8739287,
      -122.2680451,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 34,
    Capacity: 37,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 20,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 20,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 18,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 18,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 34,
    Capacity: 37,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 23,
    Capacity: 25,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 21,
    Capacity: 21,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 21,
    Capacity: 21,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 21,
    Capacity: 20,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 21,
    Capacity: 20,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 23,
    Capacity: 25,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 34,
    Capacity: 37,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 20,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 20,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 18,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 18,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 34,
    Capacity: 37,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 23,
    Capacity: 25,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 21,
    Capacity: 21,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 21,
    Capacity: 21,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 21,
    Capacity: 20,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 21,
    Capacity: 20,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 23,
    Capacity: 25,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 34,
    Capacity: 37,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 20,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 20,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 18,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 18,
    Capacity: 30,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Berkeley Dance Studio',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 34,
    Capacity: 37,
    address: '2401 Bancroft Way',
    lat: 37.8686943,
    lon: -122.2637322,
    center: [
      37.8686943,
      -122.2637322,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 184,
    Capacity: 170,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 174,
    Capacity: 164,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 141,
    Capacity: 142,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 98,
    Capacity: 100,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 139,
    Capacity: 150,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 163,
    Capacity: 174,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 144,
    Capacity: 154,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 48,
    Capacity: 48,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 194,
    Capacity: 198,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 170,
    Capacity: 174,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 146,
    Capacity: 150,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 100,
    Capacity: 100,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 124,
    Capacity: 124,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 156,
    Capacity: 26,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 184,
    Capacity: 170,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 174,
    Capacity: 164,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 141,
    Capacity: 142,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 98,
    Capacity: 100,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 139,
    Capacity: 150,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 163,
    Capacity: 174,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 144,
    Capacity: 154,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 191,
    Capacity: 198,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 191,
    Capacity: 198,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 167,
    Capacity: 174,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 100,
    Capacity: 100,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 124,
    Capacity: 124,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 156,
    Capacity: 26,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 160,
    Capacity: 146,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 150,
    Capacity: 140,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 117,
    Capacity: 118,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 98,
    Capacity: 100,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Birge',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 120,
    Capacity: 130,
    address: '100 South Drive',
    lat: 37.8722322,
    lon: -122.2597647,
    center: [
      37.8722322,
      -122.2597647,
    ],
  },
  {
    Location: 'Blum',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 17,
    Capacity: 20,
    address: 'Blum Hall',
    lat: 37.8750255,
    lon: -122.2613803,
    center: [
      37.8750255,
      -122.2613803,
    ],
  },
  {
    Location: 'Blum',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 17,
    Capacity: 20,
    address: 'Blum Hall',
    lat: 37.8750255,
    lon: -122.2613803,
    center: [
      37.8750255,
      -122.2613803,
    ],
  },
  {
    Location: 'Blum',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 17,
    Capacity: 20,
    address: 'Blum Hall',
    lat: 37.8750255,
    lon: -122.2613803,
    center: [
      37.8750255,
      -122.2613803,
    ],
  },
  {
    Location: 'Blum',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 17,
    Capacity: 20,
    address: 'Blum Hall',
    lat: 37.8750255,
    lon: -122.2613803,
    center: [
      37.8750255,
      -122.2613803,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 39,
    Capacity: 32,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 39,
    Capacity: 32,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 17,
    Capacity: 20,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 39,
    Capacity: 32,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 39,
    Capacity: 32,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 17,
    Capacity: 20,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 17,
    Capacity: 20,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 17,
    Capacity: 20,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 21,
    Capacity: 15,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 21,
    Capacity: 15,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Cal Memorial Stadium',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: '2227 Piedmont Avenue',
    lat: 37.8706571,
    lon: -122.2533532,
    center: [
      37.8706571,
      -122.2533532,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 55,
    Capacity: 56,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 27,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 30,
    Capacity: 40,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 44,
    Capacity: 70,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 81,
    Capacity: 86,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 104,
    Capacity: 116,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 53,
    Capacity: 56,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 24,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 26,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 83,
    Capacity: 86,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 5,
    Capacity: 13,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 25,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 25,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 35,
    Capacity: 40,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 25,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 55,
    Capacity: 51,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 64,
    Capacity: 64,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 30,
    Capacity: 25,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 35,
    Capacity: 40,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 44,
    Capacity: 70,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 77,
    Capacity: 86,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 111,
    Capacity: 116,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 52,
    Capacity: 56,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 26,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 84,
    Capacity: 86,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 30,
    Capacity: 40,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 22,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 24,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 25,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 26,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 25,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 26,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 20,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 21,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 26,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Campbell Hall',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 25,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731446,
    lon: -122.2596833,
    center: [
      37.8731446,
      -122.2596833,
    ],
  },
  {
    Location: 'Center for Latin American and Caribbean Studies',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 6,
    Capacity: 10,
    address: '2334 Bowditch Street',
    lat: 37.8677036,
    lon: -122.2617472,
    center: [
      37.8677036,
      -122.2617472,
    ],
  },
  {
    Location: 'Center for Latin American and Caribbean Studies',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 6,
    Capacity: 10,
    address: '2334 Bowditch Street',
    lat: 37.8677036,
    lon: -122.2617472,
    center: [
      37.8677036,
      -122.2617472,
    ],
  },
  {
    Location: 'Center for Latin American and Caribbean Studies',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1,
    Capacity: 10,
    address: '2334 Bowditch Street',
    lat: 37.8677036,
    lon: -122.2617472,
    center: [
      37.8677036,
      -122.2617472,
    ],
  },
  {
    Location: 'Center for Latin American and Caribbean Studies',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1,
    Capacity: 10,
    address: '2334 Bowditch Street',
    lat: 37.8677036,
    lon: -122.2617472,
    center: [
      37.8677036,
      -122.2617472,
    ],
  },
  {
    Location: 'Center for Latin American and Caribbean Studies',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 6,
    Capacity: 10,
    address: '2334 Bowditch Street',
    lat: 37.8677036,
    lon: -122.2617472,
    center: [
      37.8677036,
      -122.2617472,
    ],
  },
  {
    Location: 'Center for Latin American and Caribbean Studies',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 6,
    Capacity: 10,
    address: '2334 Bowditch Street',
    lat: 37.8677036,
    lon: -122.2617472,
    center: [
      37.8677036,
      -122.2617472,
    ],
  },
  {
    Location: 'Center for Latin American and Caribbean Studies',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1,
    Capacity: 10,
    address: '2334 Bowditch Street',
    lat: 37.8677036,
    lon: -122.2617472,
    center: [
      37.8677036,
      -122.2617472,
    ],
  },
  {
    Location: 'Center for Latin American and Caribbean Studies',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1,
    Capacity: 10,
    address: '2334 Bowditch Street',
    lat: 37.8677036,
    lon: -122.2617472,
    center: [
      37.8677036,
      -122.2617472,
    ],
  },
  {
    Location: 'Center for the Study of Law and Society',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 15,
    Capacity: 13,
    address: '2240 Piedmont Avenue',
    lat: 37.8703966,
    lon: -122.2554541,
    center: [
      37.8703966,
      -122.2554541,
    ],
  },
  {
    Location: 'Center for the Study of Law and Society',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 15,
    Capacity: 13,
    address: '2240 Piedmont Avenue',
    lat: 37.8703966,
    lon: -122.2554541,
    center: [
      37.8703966,
      -122.2554541,
    ],
  },
  {
    Location: 'Center for the Study of Law and Society',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 15,
    Capacity: 13,
    address: '2240 Piedmont Avenue',
    lat: 37.8703966,
    lon: -122.2554541,
    center: [
      37.8703966,
      -122.2554541,
    ],
  },
  {
    Location: 'Chavez',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 59,
    Capacity: 80,
    address: 'Cesar Chavez Student Center',
    lat: 37.8695337,
    lon: -122.2629075,
    center: [
      37.8695337,
      -122.2629075,
    ],
  },
  {
    Location: 'Chavez',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 59,
    Capacity: 80,
    address: 'Cesar Chavez Student Center',
    lat: 37.8695337,
    lon: -122.2629075,
    center: [
      37.8695337,
      -122.2629075,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 156,
    Capacity: 159,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 26,
    Capacity: 29,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 48,
    Capacity: 62,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 48,
    Capacity: 62,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 126,
    Capacity: 130,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 298,
    Capacity: 400,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 172,
    Capacity: 270,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 131,
    Capacity: 130,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 287,
    Capacity: 289,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 253,
    Capacity: 249,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 213,
    Capacity: 221,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 234,
    Capacity: 242,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 107,
    Capacity: 123,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 46,
    Capacity: 62,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 52,
    Capacity: 62,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 257,
    Capacity: 354,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 264,
    Capacity: 351,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 213,
    Capacity: 242,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 373,
    Capacity: 397,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 130,
    Capacity: 130,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 62,
    Capacity: 77,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 110,
    Capacity: 139,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 110,
    Capacity: 139,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 159,
    Capacity: 165,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 328,
    Capacity: 430,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 172,
    Capacity: 270,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 131,
    Capacity: 130,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 261,
    Capacity: 260,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 163,
    Capacity: 161,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 178,
    Capacity: 186,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 178,
    Capacity: 186,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 74,
    Capacity: 93,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 74,
    Capacity: 93,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 52,
    Capacity: 62,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 257,
    Capacity: 354,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 205,
    Capacity: 292,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 150,
    Capacity: 178,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 313,
    Capacity: 339,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 64,
    Capacity: 88,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 134,
    Capacity: 218,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 18,
    Capacity: 68,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 18,
    Capacity: 28,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 18,
    Capacity: 28,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 88,
    Capacity: 90,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 123,
    Capacity: 152,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Cheit',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 33,
    Capacity: 62,
    address: 'Cheit Hall',
    lat: 37.8716852,
    lon: -122.2569139,
    center: [
      37.8716852,
      -122.2569139,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 280,
    Capacity: 364,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 187,
    Capacity: 303,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 257,
    Capacity: 373,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 301,
    Capacity: 312,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 231,
    Capacity: 242,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 156,
    Capacity: 175,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 328,
    Capacity: 350,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 172,
    Capacity: 175,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 272,
    Capacity: 272,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 552,
    Capacity: 636,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 287,
    Capacity: 338,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 114,
    Capacity: 127,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 114,
    Capacity: 127,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 41,
    Capacity: 57,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 41,
    Capacity: 57,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 36,
    Capacity: 36,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 99,
    Capacity: 93,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 63,
    Capacity: 57,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 81,
    Capacity: 89,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 368,
    Capacity: 427,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 232,
    Capacity: 298,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 156,
    Capacity: 260,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 226,
    Capacity: 330,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 230,
    Capacity: 232,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 128,
    Capacity: 130,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 156,
    Capacity: 175,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 328,
    Capacity: 350,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 172,
    Capacity: 175,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 272,
    Capacity: 272,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 471,
    Capacity: 540,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 341,
    Capacity: 408,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 114,
    Capacity: 159,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 114,
    Capacity: 159,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 79,
    Capacity: 122,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 13,
    Capacity: 13,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 36,
    Capacity: 36,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 99,
    Capacity: 93,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 63,
    Capacity: 57,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 81,
    Capacity: 89,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 422,
    Capacity: 497,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 43,
    Capacity: 43,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 172,
    Capacity: 185,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 34,
    Capacity: 44,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 38,
    Capacity: 43,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 78,
    Capacity: 100,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 46,
    Capacity: 57,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Chou Hall',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 43,
    Capacity: 43,
    address: 'Cheit Lane',
    lat: 37.8722997,
    lon: -122.2571185,
    center: [
      37.8722997,
      -122.2571185,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 279,
    Capacity: 294,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 47,
    Capacity: 53,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 132,
    Capacity: 139,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 101,
    Capacity: 122,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 204,
    Capacity: 209,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 174,
    Capacity: 179,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 36,
    Capacity: 34,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 98,
    Capacity: 124,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 60,
    Capacity: 64,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 134,
    Capacity: 148,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 256,
    Capacity: 269,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 226,
    Capacity: 238,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 139,
    Capacity: 134,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 232,
    Capacity: 269,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 291,
    Capacity: 353,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 72,
    Capacity: 100,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 136,
    Capacity: 170,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 96,
    Capacity: 130,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 48,
    Capacity: 117,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 34,
    Capacity: 38,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 286,
    Capacity: 385,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 34,
    Capacity: 38,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 225,
    Capacity: 256,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 109,
    Capacity: 118,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 227,
    Capacity: 218,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 196,
    Capacity: 206,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 104,
    Capacity: 120,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 153,
    Capacity: 178,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 80,
    Capacity: 106,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 236,
    Capacity: 272,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 198,
    Capacity: 215,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 15,
    Capacity: 15,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 98,
    Capacity: 124,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 29,
    Capacity: 38,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 90,
    Capacity: 109,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 29,
    Capacity: 38,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 131,
    Capacity: 138,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 211,
    Capacity: 221,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 201,
    Capacity: 221,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 139,
    Capacity: 134,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 251,
    Capacity: 286,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 367,
    Capacity: 430,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 115,
    Capacity: 142,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 109,
    Capacity: 148,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 94,
    Capacity: 128,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 18,
    Capacity: 18,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 65,
    Capacity: 133,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 317,
    Capacity: 422,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 238,
    Capacity: 272,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 105,
    Capacity: 118,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 227,
    Capacity: 218,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 85,
    Capacity: 89,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 147,
    Capacity: 156,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 139,
    Capacity: 156,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 133,
    Capacity: 136,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 68,
    Capacity: 66,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 68,
    Capacity: 66,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 38,
    Capacity: 36,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 92,
    Capacity: 117,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 24,
    Capacity: 25,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 71,
    Capacity: 74,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 199,
    Capacity: 212,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Cory',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 47,
    Capacity: 49,
    address: 'Cory Hall',
    lat: 37.8750913,
    lon: -122.2603827,
    center: [
      37.8750913,
      -122.2603827,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 39,
    Capacity: 42,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 51,
    Capacity: 67,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 51,
    Capacity: 67,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 81,
    Capacity: 130,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 132,
    Capacity: 185,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 89,
    Capacity: 185,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 17,
    Capacity: 85,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 29,
    Capacity: 65,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 27,
    Capacity: 40,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 46,
    Capacity: 54,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 29,
    Capacity: 50,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 122,
    Capacity: 130,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 224,
    Capacity: 230,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 132,
    Capacity: 130,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 58,
    Capacity: 55,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 73,
    Capacity: 110,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 98,
    Capacity: 150,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 101,
    Capacity: 130,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 47,
    Capacity: 65,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 162,
    Capacity: 198,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 61,
    Capacity: 68,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 103,
    Capacity: 124,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 42,
    Capacity: 85,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 70,
    Capacity: 129,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 45,
    Capacity: 89,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 97,
    Capacity: 164,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 76,
    Capacity: 89,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 37,
    Capacity: 40,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 37,
    Capacity: 40,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 29,
    Capacity: 65,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 27,
    Capacity: 40,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 29,
    Capacity: 50,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 122,
    Capacity: 130,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 225,
    Capacity: 230,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 222,
    Capacity: 225,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 82,
    Capacity: 90,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 51,
    Capacity: 85,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 123,
    Capacity: 185,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 101,
    Capacity: 130,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 162,
    Capacity: 198,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 61,
    Capacity: 68,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 103,
    Capacity: 124,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 42,
    Capacity: 85,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 33,
    Capacity: 35,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 54,
    Capacity: 70,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 56,
    Capacity: 82,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 29,
    Capacity: 52,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 2,
    Capacity: 12,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Friday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 2,
    Capacity: 12,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 28,
    Capacity: 60,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Davis',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 33,
    Capacity: 35,
    address: 'Davis Hall',
    lat: 37.8745656,
    lon: -122.260659,
    center: [
      37.8745656,
      -122.260659,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 9,
    Capacity: 10,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 25,
    Capacity: 27,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 37,
    Capacity: 47,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 47,
    Capacity: 57,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 47,
    Capacity: 49,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 46,
    Capacity: 67,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 46,
    Capacity: 67,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 18,
    Capacity: 18,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 31,
    Capacity: 32,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 31,
    Capacity: 32,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 71,
    Capacity: 81,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 118,
    Capacity: 130,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 15,
    Capacity: 15,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 15,
    Capacity: 15,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 15,
    Capacity: 15,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 14,
    Capacity: 20,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 18,
    Capacity: 20,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 30,
    Capacity: 40,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 10,
    Capacity: 20,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 47,
    Capacity: 49,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 28,
    Capacity: 49,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 28,
    Capacity: 49,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 17,
    Capacity: 17,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 17,
    Capacity: 17,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 57,
    Capacity: 66,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 104,
    Capacity: 115,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 10,
    Capacity: 15,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 10,
    Capacity: 15,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 10,
    Capacity: 15,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 20,
    Capacity: 20,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Doe Library',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Campanile Way',
    lat: 37.8722068,
    lon: -122.2618116,
    center: [
      37.8722068,
      -122.2618116,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 73,
    Capacity: 67,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 14,
    Capacity: 15,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 14,
    Capacity: 15,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 80,
    Capacity: 80,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 80,
    Capacity: 80,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 67,
    Capacity: 70,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 75,
    Capacity: 75,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 75,
    Capacity: 75,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 30,
    Capacity: 45,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 30,
    Capacity: 45,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 14,
    Capacity: 15,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 14,
    Capacity: 15,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 0,
    Capacity: 0,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 80,
    Capacity: 80,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 80,
    Capacity: 80,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 75,
    Capacity: 75,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 75,
    Capacity: 75,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 30,
    Capacity: 45,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 30,
    Capacity: 45,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 50,
    Capacity: 68,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Donner Lab',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 50,
    Capacity: 68,
    address: 'Donner Lab',
    lat: 37.8744177,
    lon: -122.2577925,
    center: [
      37.8744177,
      -122.2577925,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1375,
    Capacity: 1493,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1560,
    Capacity: 1704,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1745,
    Capacity: 1791,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 1236,
    Capacity: 1306,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 1224,
    Capacity: 1265,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 1168,
    Capacity: 1225,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 203,
    Capacity: 227,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 366,
    Capacity: 410,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 14,
    Capacity: 20,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1101,
    Capacity: 1200,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1637,
    Capacity: 1812,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1417,
    Capacity: 1540,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1488,
    Capacity: 1627,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1500,
    Capacity: 1655,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1406,
    Capacity: 1577,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 2839,
    Capacity: 3136,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 1762,
    Capacity: 1935,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 1502,
    Capacity: 1561,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 1636,
    Capacity: 1767,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 601,
    Capacity: 717,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 909,
    Capacity: 508,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 67,
    Capacity: 92,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1717,
    Capacity: 1788,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1517,
    Capacity: 1619,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1797,
    Capacity: 1930,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 2911,
    Capacity: 3140,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1305,
    Capacity: 1444,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1422,
    Capacity: 1550,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1915,
    Capacity: 1923,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 1025,
    Capacity: 1080,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 1304,
    Capacity: 1434,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 1185,
    Capacity: 1319,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 247,
    Capacity: 324,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 420,
    Capacity: 487,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 13,
    Capacity: 25,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1221,
    Capacity: 1349,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1731,
    Capacity: 1905,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1427,
    Capacity: 1565,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1454,
    Capacity: 1618,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1453,
    Capacity: 1595,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1313,
    Capacity: 1448,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 2657,
    Capacity: 2903,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 1577,
    Capacity: 1714,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 1125,
    Capacity: 1183,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 1329,
    Capacity: 1416,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 462,
    Capacity: 494,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 911,
    Capacity: 519,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 41,
    Capacity: 20,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1741,
    Capacity: 1808,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1493,
    Capacity: 1596,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1870,
    Capacity: 2002,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 2832,
    Capacity: 3051,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1251,
    Capacity: 1393,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 706,
    Capacity: 817,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1351,
    Capacity: 1376,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 332,
    Capacity: 368,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 166,
    Capacity: 189,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 39,
    Capacity: 57,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 11,
    Capacity: 27,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 332,
    Capacity: 390,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1157,
    Capacity: 1262,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1704,
    Capacity: 1880,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1389,
    Capacity: 1499,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Dwinelle',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1490,
    Capacity: 1611,
    address: 'South Drive',
    lat: 37.8705318,
    lon: -122.2631791,
    center: [
      37.8705318,
      -122.2631791,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 190,
    Capacity: 202,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 59,
    Capacity: 70,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 135,
    Capacity: 121,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 297,
    Capacity: 300,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 125,
    Capacity: 131,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 57,
    Capacity: 90,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 156,
    Capacity: 187,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 134,
    Capacity: 165,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 238,
    Capacity: 239,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 26,
    Capacity: 30,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 142,
    Capacity: 184,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 188,
    Capacity: 219,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 382,
    Capacity: 469,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 224,
    Capacity: 280,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 120,
    Capacity: 125,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 80,
    Capacity: 85,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 59,
    Capacity: 60,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 248,
    Capacity: 265,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 328,
    Capacity: 345,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 155,
    Capacity: 167,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 208,
    Capacity: 266,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 182,
    Capacity: 188,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 122,
    Capacity: 120,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 152,
    Capacity: 173,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 128,
    Capacity: 186,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 124,
    Capacity: 155,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 92,
    Capacity: 125,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 191,
    Capacity: 222,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 128,
    Capacity: 155,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 209,
    Capacity: 214,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 89,
    Capacity: 117,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 132,
    Capacity: 176,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 212,
    Capacity: 244,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 400,
    Capacity: 489,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 260,
    Capacity: 317,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 114,
    Capacity: 118,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 114,
    Capacity: 118,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 59,
    Capacity: 60,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 262,
    Capacity: 285,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 352,
    Capacity: 374,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 111,
    Capacity: 121,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 177,
    Capacity: 223,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 263,
    Capacity: 266,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 183,
    Capacity: 204,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 130,
    Capacity: 149,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 116,
    Capacity: 119,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 76,
    Capacity: 105,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 18,
    Capacity: 34,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 174,
    Capacity: 221,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 127,
    Capacity: 137,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 305,
    Capacity: 311,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Etcheverry',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 101,
    Capacity: 107,
    address: '2505 Hearst Avenue',
    lat: 37.8756571,
    lon: -122.2618581,
    center: [
      37.8756571,
      -122.2618581,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 250,
    Capacity: 301,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 211,
    Capacity: 270,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 393,
    Capacity: 417,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 208,
    Capacity: 216,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 141,
    Capacity: 144,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 186,
    Capacity: 186,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 118,
    Capacity: 121,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 383,
    Capacity: 451,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 533,
    Capacity: 537,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 296,
    Capacity: 345,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 418,
    Capacity: 461,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 819,
    Capacity: 649,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 502,
    Capacity: 523,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 564,
    Capacity: 573,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 364,
    Capacity: 366,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 355,
    Capacity: 353,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 652,
    Capacity: 654,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 349,
    Capacity: 354,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 410,
    Capacity: 426,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 823,
    Capacity: 871,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 843,
    Capacity: 635,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 664,
    Capacity: 842,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 938,
    Capacity: 1142,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 358,
    Capacity: 419,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 638,
    Capacity: 703,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 555,
    Capacity: 585,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 570,
    Capacity: 611,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 329,
    Capacity: 372,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 190,
    Capacity: 213,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 149,
    Capacity: 150,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 509,
    Capacity: 551,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 630,
    Capacity: 636,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 417,
    Capacity: 478,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 621,
    Capacity: 668,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 719,
    Capacity: 538,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 674,
    Capacity: 692,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 771,
    Capacity: 789,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 528,
    Capacity: 546,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 433,
    Capacity: 451,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 636,
    Capacity: 652,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 333,
    Capacity: 352,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 353,
    Capacity: 368,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 863,
    Capacity: 916,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 856,
    Capacity: 683,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 730,
    Capacity: 907,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1009,
    Capacity: 1216,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 240,
    Capacity: 267,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 265,
    Capacity: 328,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 157,
    Capacity: 178,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 99,
    Capacity: 97,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 38,
    Capacity: 38,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 40,
    Capacity: 42,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 437,
    Capacity: 515,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 576,
    Capacity: 605,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 377,
    Capacity: 437,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'Evans',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 563,
    Capacity: 605,
    address: 'University Drive',
    lat: 37.8736125,
    lon: -122.260169,
    center: [
      37.8736125,
      -122.260169,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 27,
    Capacity: 35,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 45,
    Capacity: 45,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 45,
    Capacity: 45,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 45,
    Capacity: 45,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 35,
    Capacity: 35,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 109,
    Capacity: 110,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 82,
    Capacity: 82,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 72,
    Capacity: 80,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 162,
    Capacity: 166,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 248,
    Capacity: 252,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 172,
    Capacity: 172,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 58,
    Capacity: 90,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 138,
    Capacity: 170,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 80,
    Capacity: 80,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 72,
    Capacity: 75,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 144,
    Capacity: 155,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 27,
    Capacity: 35,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 41,
    Capacity: 40,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 41,
    Capacity: 40,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 41,
    Capacity: 40,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 41,
    Capacity: 40,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 35,
    Capacity: 35,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 109,
    Capacity: 110,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 82,
    Capacity: 82,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 72,
    Capacity: 80,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 76,
    Capacity: 80,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 162,
    Capacity: 166,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 86,
    Capacity: 86,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 58,
    Capacity: 90,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 138,
    Capacity: 170,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 80,
    Capacity: 80,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 72,
    Capacity: 75,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 144,
    Capacity: 155,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 27,
    Capacity: 35,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 81,
    Capacity: 60,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 81,
    Capacity: 60,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 81,
    Capacity: 60,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 74,
    Capacity: 75,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GSPP',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 82,
    Capacity: 82,
    address: '2607 Hearst Ave',
    lat: 37.8757268,
    lon: -122.2604332,
    center: [
      37.8757268,
      -122.2604332,
    ],
  },
  {
    Location: 'GTU Student Services Center',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 36,
    Capacity: 36,
    address: '2465 Le Conte Avenue',
    lat: 37.8770811,
    lon: -122.2639451,
    center: [
      37.8770811,
      -122.2639451,
    ],
  },
  {
    Location: 'GTU Student Services Center',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 36,
    Capacity: 36,
    address: '2465 Le Conte Avenue',
    lat: 37.8770811,
    lon: -122.2639451,
    center: [
      37.8770811,
      -122.2639451,
    ],
  },
  {
    Location: 'GTU Student Services Center',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 36,
    Capacity: 36,
    address: '2465 Le Conte Avenue',
    lat: 37.8770811,
    lon: -122.2639451,
    center: [
      37.8770811,
      -122.2639451,
    ],
  },
  {
    Location: 'GTU Student Services Center',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 36,
    Capacity: 36,
    address: '2465 Le Conte Avenue',
    lat: 37.8770811,
    lon: -122.2639451,
    center: [
      37.8770811,
      -122.2639451,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 169,
    Capacity: 170,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 249,
    Capacity: 57,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 264,
    Capacity: 71,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 270,
    Capacity: 73,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 188,
    Capacity: 186,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 182,
    Capacity: 198,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 22,
    Capacity: 40,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 152,
    Capacity: 152,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 200,
    Capacity: 214,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 177,
    Capacity: 180,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 229,
    Capacity: 257,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 247,
    Capacity: 256,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 284,
    Capacity: 296,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 47,
    Capacity: 52,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 224,
    Capacity: 236,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 224,
    Capacity: 236,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 35,
    Capacity: 40,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 203,
    Capacity: 204,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 427,
    Capacity: 430,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 249,
    Capacity: 251,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 160,
    Capacity: 157,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 370,
    Capacity: 376,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 192,
    Capacity: 194,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 80,
    Capacity: 103,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 80,
    Capacity: 97,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 80,
    Capacity: 101,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 187,
    Capacity: 186,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 160,
    Capacity: 158,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 152,
    Capacity: 152,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 193,
    Capacity: 207,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 173,
    Capacity: 173,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 269,
    Capacity: 279,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 283,
    Capacity: 292,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 320,
    Capacity: 332,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 60,
    Capacity: 64,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 189,
    Capacity: 196,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 189,
    Capacity: 196,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 203,
    Capacity: 204,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 414,
    Capacity: 418,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 236,
    Capacity: 239,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 147,
    Capacity: 145,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 393,
    Capacity: 400,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 140,
    Capacity: 140,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 152,
    Capacity: 152,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Genetics & Plant Bio',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 23,
    Capacity: 34,
    address: 'Genetics and Plant Biology Building',
    lat: 37.8734357,
    lon: -122.2673241,
    center: [
      37.8734357,
      -122.2673241,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 28,
    Capacity: 50,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 28,
    Capacity: 50,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 36,
    Capacity: 50,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 36,
    Capacity: 50,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 47,
    Capacity: 54,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 47,
    Capacity: 54,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 36,
    Capacity: 38,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 42,
    Capacity: 40,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 42,
    Capacity: 40,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 68,
    Capacity: 69,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 68,
    Capacity: 69,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 21,
    Capacity: 25,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 69,
    Capacity: 98,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 50,
    Capacity: 73,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 47,
    Capacity: 74,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 60,
    Capacity: 89,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 49,
    Capacity: 48,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 38,
    Capacity: 60,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 38,
    Capacity: 60,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 10,
    Capacity: 10,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 16,
    Capacity: 24,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 25,
    Capacity: 64,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 29,
    Capacity: 45,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 29,
    Capacity: 45,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 14,
    Capacity: 14,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 14,
    Capacity: 14,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 23,
    Capacity: 23,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 42,
    Capacity: 40,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 42,
    Capacity: 40,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 19,
    Capacity: 20,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 41,
    Capacity: 45,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 69,
    Capacity: 98,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 50,
    Capacity: 73,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 50,
    Capacity: 75,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 50,
    Capacity: 75,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 20,
    Capacity: 20,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 14,
    Capacity: 14,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 14,
    Capacity: 14,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Giannini',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Giannini Hall',
    lat: 37.8735349,
    lon: -122.2648735,
    center: [
      37.8735349,
      -122.2648735,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Gilman',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'South Drive',
    lat: 37.8726066,
    lon: -122.2588058,
    center: [
      37.8726066,
      -122.2588058,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 34,
    Capacity: 34,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 121,
    Capacity: 123,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 111,
    Capacity: 113,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 96,
    Capacity: 96,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 89,
    Capacity: 96,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 262,
    Capacity: 262,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 180,
    Capacity: 179,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 63,
    Capacity: 61,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 22,
    Capacity: 20,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 264,
    Capacity: 303,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 190,
    Capacity: 229,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 192,
    Capacity: 206,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 99,
    Capacity: 104,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 104,
    Capacity: 106,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 64,
    Capacity: 65,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 85,
    Capacity: 120,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 309,
    Capacity: 349,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 331,
    Capacity: 349,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 241,
    Capacity: 257,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 335,
    Capacity: 352,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 58,
    Capacity: 58,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 141,
    Capacity: 147,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 111,
    Capacity: 113,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 96,
    Capacity: 96,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 89,
    Capacity: 96,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 232,
    Capacity: 232,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 149,
    Capacity: 149,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 62,
    Capacity: 61,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 21,
    Capacity: 20,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 240,
    Capacity: 279,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 195,
    Capacity: 229,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 216,
    Capacity: 230,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 133,
    Capacity: 152,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 113,
    Capacity: 130,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 64,
    Capacity: 65,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 85,
    Capacity: 120,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 309,
    Capacity: 349,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 331,
    Capacity: 349,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 241,
    Capacity: 257,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 311,
    Capacity: 328,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 47,
    Capacity: 72,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 12,
    Capacity: 24,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 41,
    Capacity: 48,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 120,
    Capacity: 120,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 47,
    Capacity: 48,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 45,
    Capacity: 48,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Golden Bear Center',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 43,
    Capacity: 72,
    address: '1995 University Ave Suite 120, Berkeley, CA 94704',
    lat: 37.872094,
    lon: -122.2738613,
    center: [
      37.872094,
      -122.2738613,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 238,
    Capacity: 240,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 238,
    Capacity: 240,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 285,
    Capacity: 299,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 285,
    Capacity: 299,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 254,
    Capacity: 250,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 309,
    Capacity: 314,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 447,
    Capacity: 465,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 138,
    Capacity: 151,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 257,
    Capacity: 260,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 522,
    Capacity: 529,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 265,
    Capacity: 269,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 510,
    Capacity: 515,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 764,
    Capacity: 765,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 269,
    Capacity: 276,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 275,
    Capacity: 291,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 275,
    Capacity: 291,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 269,
    Capacity: 272,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 269,
    Capacity: 272,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 269,
    Capacity: 276,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 254,
    Capacity: 250,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 309,
    Capacity: 314,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 447,
    Capacity: 465,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 138,
    Capacity: 151,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 257,
    Capacity: 260,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 522,
    Capacity: 529,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 265,
    Capacity: 269,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 510,
    Capacity: 515,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haas Faculty Wing',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 764,
    Capacity: 765,
    address: '2220 Piedmont Avenue',
    lat: 37.8720622,
    lon: -122.2565937,
    center: [
      37.8720622,
      -122.2565937,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 20,
    Capacity: 31,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 51,
    Capacity: 57,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 48,
    Capacity: 54,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 75,
    Capacity: 104,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 58,
    Capacity: 67,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 66,
    Capacity: 71,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 16,
    Capacity: 34,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 33,
    Capacity: 51,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 17,
    Capacity: 17,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 20,
    Capacity: 31,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 68,
    Capacity: 68,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 44,
    Capacity: 44,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 91,
    Capacity: 95,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 61,
    Capacity: 65,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 50,
    Capacity: 50,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 50,
    Capacity: 50,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 39,
    Capacity: 42,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 86,
    Capacity: 86,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 78,
    Capacity: 91,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 50,
    Capacity: 82,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 47,
    Capacity: 79,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 77,
    Capacity: 93,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 30,
    Capacity: 47,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 66,
    Capacity: 71,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 45,
    Capacity: 65,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 62,
    Capacity: 81,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 65,
    Capacity: 84,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 78,
    Capacity: 91,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 14,
    Capacity: 14,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 44,
    Capacity: 44,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 91,
    Capacity: 95,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 81,
    Capacity: 85,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 61,
    Capacity: 70,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 43,
    Capacity: 50,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 50,
    Capacity: 50,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 50,
    Capacity: 50,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 74,
    Capacity: 72,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 69,
    Capacity: 72,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 30,
    Capacity: 31,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 17,
    Capacity: 17,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 14,
    Capacity: 14,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 14,
    Capacity: 14,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 50,
    Capacity: 54,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 14,
    Capacity: 14,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 31,
    Capacity: 31,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 34,
    Capacity: 34,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Haviland',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 13,
    Capacity: 14,
    address: 'Haviland Hall',
    lat: 37.8737118,
    lon: -122.2636233,
    center: [
      37.8737118,
      -122.2636233,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 204,
    Capacity: 240,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 237,
    Capacity: 240,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 211,
    Capacity: 3,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 13,
    Capacity: 30,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 216,
    Capacity: 250,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 203,
    Capacity: 220,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 29,
    Capacity: 30,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 29,
    Capacity: 30,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 61,
    Capacity: 60,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 211,
    Capacity: 250,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 368,
    Capacity: 410,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 168,
    Capacity: 200,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 196,
    Capacity: 218,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 196,
    Capacity: 218,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1047,
    Capacity: 1054,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1072,
    Capacity: 1079,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 233,
    Capacity: 249,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 294,
    Capacity: 309,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 204,
    Capacity: 240,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 237,
    Capacity: 240,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 231,
    Capacity: 23,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 221,
    Capacity: 250,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 203,
    Capacity: 220,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 29,
    Capacity: 30,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 29,
    Capacity: 30,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 66,
    Capacity: 65,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 225,
    Capacity: 235,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 382,
    Capacity: 395,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 157,
    Capacity: 160,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 202,
    Capacity: 208,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 202,
    Capacity: 208,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1047,
    Capacity: 1054,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1047,
    Capacity: 1054,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 223,
    Capacity: 229,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 259,
    Capacity: 264,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 29,
    Capacity: 30,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Field Annex',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 209,
    Capacity: 210,
    address: '2545-2581 Bancroft Way',
    lat: 37.8692322,
    lon: -122.2601344,
    center: [
      37.8692322,
      -122.2601344,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 182,
    Capacity: 187,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 110,
    Capacity: 112,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 85,
    Capacity: 90,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 21,
    Capacity: 26,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '07:00am-08:00am',
    Enrolled: 26,
    Capacity: 35,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 52,
    Capacity: 55,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 118,
    Capacity: 124,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 184,
    Capacity: 187,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 180,
    Capacity: 167,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 187,
    Capacity: 198,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 162,
    Capacity: 182,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 133,
    Capacity: 152,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 94,
    Capacity: 110,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '06:00am-07:00am',
    Enrolled: 45,
    Capacity: 65,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '07:00am-08:00am',
    Enrolled: 25,
    Capacity: 35,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 66,
    Capacity: 60,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 85,
    Capacity: 87,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 134,
    Capacity: 139,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 168,
    Capacity: 175,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 138,
    Capacity: 156,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 117,
    Capacity: 120,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 109,
    Capacity: 135,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 109,
    Capacity: 135,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 49,
    Capacity: 56,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '06:00am-07:00am',
    Enrolled: 45,
    Capacity: 65,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '07:00am-08:00am',
    Enrolled: 26,
    Capacity: 35,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 74,
    Capacity: 80,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 141,
    Capacity: 149,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 183,
    Capacity: 190,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 178,
    Capacity: 170,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 172,
    Capacity: 178,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 139,
    Capacity: 145,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 133,
    Capacity: 147,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 120,
    Capacity: 129,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 24,
    Capacity: 24,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 6,
    Capacity: 20,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '06:00am-07:00am',
    Enrolled: 40,
    Capacity: 64,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 6,
    Capacity: 20,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '07:00am-08:00am',
    Enrolled: 65,
    Capacity: 99,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 6,
    Capacity: 20,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 106,
    Capacity: 124,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 107,
    Capacity: 120,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 83,
    Capacity: 107,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 120,
    Capacity: 141,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 142,
    Capacity: 139,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 72,
    Capacity: 72,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 21,
    Capacity: 22,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 21,
    Capacity: 26,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Friday',
    TimeBlock: '06:00am-07:00am',
    Enrolled: 45,
    Capacity: 65,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 10,
    Capacity: 85,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 33,
    Capacity: 107,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 49,
    Capacity: 53,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Gym',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 49,
    Capacity: 48,
    address: 'Hearst Memorial Gymnasium',
    lat: 37.8695377,
    lon: -122.2595529,
    center: [
      37.8695377,
      -122.2595529,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 170,
    Capacity: 250,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 151,
    Capacity: 176,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 240,
    Capacity: 245,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 43,
    Capacity: 45,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 139,
    Capacity: 160,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 139,
    Capacity: 160,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 114,
    Capacity: 117,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 171,
    Capacity: 178,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 206,
    Capacity: 235,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 199,
    Capacity: 261,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 224,
    Capacity: 237,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 384,
    Capacity: 394,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 193,
    Capacity: 190,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 173,
    Capacity: 170,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 167,
    Capacity: 170,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 161,
    Capacity: 150,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 179,
    Capacity: 190,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 66,
    Capacity: 65,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 195,
    Capacity: 213,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 394,
    Capacity: 474,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 197,
    Capacity: 250,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 184,
    Capacity: 209,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 273,
    Capacity: 278,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 76,
    Capacity: 78,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 27,
    Capacity: 33,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 31,
    Capacity: 41,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 141,
    Capacity: 150,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 174,
    Capacity: 180,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 208,
    Capacity: 235,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 199,
    Capacity: 261,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 224,
    Capacity: 237,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 384,
    Capacity: 394,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 193,
    Capacity: 190,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 171,
    Capacity: 170,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 171,
    Capacity: 170,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 161,
    Capacity: 150,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 179,
    Capacity: 190,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 18,
    Capacity: 40,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 147,
    Capacity: 188,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 346,
    Capacity: 449,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 155,
    Capacity: 170,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 105,
    Capacity: 128,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 151,
    Capacity: 152,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 16,
    Capacity: 18,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 164,
    Capacity: 152,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 223,
    Capacity: 215,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Mining',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 209,
    Capacity: 195,
    address: 'Hearst Memorial Mining Building',
    lat: 37.8741545,
    lon: -122.2597671,
    center: [
      37.8741545,
      -122.2597671,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 28,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 21,
    Capacity: 22,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 21,
    Capacity: 22,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 14,
    Capacity: 18,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 19,
    Capacity: 22,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 22,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 25,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 22,
    Capacity: 22,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 22,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 22,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 19,
    Capacity: 18,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 28,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 35,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 35,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 14,
    Capacity: 18,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 19,
    Capacity: 22,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 22,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 25,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 22,
    Capacity: 22,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 22,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 22,
    Capacity: 24,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hearst Pool',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 19,
    Capacity: 18,
    address: 'Bancroft Way & Bowditch Street',
    lat: 37.8696844,
    lon: -122.2595171,
    center: [
      37.8696844,
      -122.2595171,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 28,
    Capacity: 40,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 28,
    Capacity: 40,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 18,
    Capacity: 30,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Monday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 18,
    Capacity: 30,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 48,
    Capacity: 80,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 48,
    Capacity: 80,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 61,
    Capacity: 125,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 61,
    Capacity: 125,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Tuesday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 61,
    Capacity: 125,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 28,
    Capacity: 40,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 28,
    Capacity: 40,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 64,
    Capacity: 100,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Wednesday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 64,
    Capacity: 100,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 48,
    Capacity: 80,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 48,
    Capacity: 80,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 61,
    Capacity: 125,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Thursday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 61,
    Capacity: 125,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hertz',
    Day: 'Thursday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 61,
    Capacity: 125,
    address: 'Hertz Hall',
    lat: 37.8710811,
    lon: -122.2582743,
    center: [
      37.8710811,
      -122.2582743,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 35,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 35,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 35,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 35,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 35,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 35,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 16,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 16,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 16,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 16,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 4,
    Capacity: 2,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 4,
    Capacity: 2,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 7,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 7,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 7,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 7,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 7,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 7,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 26,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 26,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 24,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 7,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 7,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 7,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 7,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 7,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 7,
    Capacity: 14,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 26,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 26,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 26,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 26,
    Capacity: 30,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 13,
    Capacity: 13,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 13,
    Capacity: 13,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 6,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 6,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 6,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 6,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 6,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 6,
    Capacity: 4,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 5,
    Capacity: 2,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 5,
    Capacity: 2,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 5,
    Capacity: 2,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 5,
    Capacity: 2,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 18,
    Capacity: 15,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 18,
    Capacity: 15,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 8,
    Capacity: 29,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 8,
    Capacity: 29,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 8,
    Capacity: 29,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 8,
    Capacity: 29,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 8,
    Capacity: 29,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 8,
    Capacity: 29,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 6,
    Capacity: 6,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 6,
    Capacity: 6,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 6,
    Capacity: 6,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 6,
    Capacity: 6,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 6,
    Capacity: 6,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hesse',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 6,
    Capacity: 6,
    address: 'Hesse Hall',
    lat: 37.8743128,
    lon: -122.2619257,
    center: [
      37.8743128,
      -122.2619257,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 98,
    Capacity: 99,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 286,
    Capacity: 294,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 258,
    Capacity: 266,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 168,
    Capacity: 176,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 84,
    Capacity: 86,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 264,
    Capacity: 264,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 114,
    Capacity: 115,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 180,
    Capacity: 180,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 237,
    Capacity: 237,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 237,
    Capacity: 240,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 210,
    Capacity: 210,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 204,
    Capacity: 198,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 42,
    Capacity: 36,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 18,
    Capacity: 18,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 15,
    Capacity: 17,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 165,
    Capacity: 167,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 60,
    Capacity: 60,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 60,
    Capacity: 60,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 46,
    Capacity: 55,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 84,
    Capacity: 84,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 286,
    Capacity: 289,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 168,
    Capacity: 171,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 90,
    Capacity: 90,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 26,
    Capacity: 25,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 172,
    Capacity: 176,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 264,
    Capacity: 264,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 114,
    Capacity: 115,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 236,
    Capacity: 236,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 213,
    Capacity: 210,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 210,
    Capacity: 210,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 235,
    Capacity: 237,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 212,
    Capacity: 215,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 50,
    Capacity: 53,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 33,
    Capacity: 18,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 15,
    Capacity: 0,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 15,
    Capacity: 17,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 73,
    Capacity: 79,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 30,
    Capacity: 30,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 60,
    Capacity: 60,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 86,
    Capacity: 84,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 264,
    Capacity: 264,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 146,
    Capacity: 146,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 180,
    Capacity: 180,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 146,
    Capacity: 146,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 174,
    Capacity: 174,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 114,
    Capacity: 115,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Hildebrand',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 236,
    Capacity: 236,
    address: 'Hildebrand Hall',
    lat: 37.8725916,
    lon: -122.2579178,
    center: [
      37.8725916,
      -122.2579178,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 38,
    Capacity: 30,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 29,
    Capacity: 55,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 56,
    Capacity: 90,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 59,
    Capacity: 155,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 32,
    Capacity: 120,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 115,
    Capacity: 120,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 50,
    Capacity: 51,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 50,
    Capacity: 51,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 38,
    Capacity: 30,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 87,
    Capacity: 95,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 74,
    Capacity: 75,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 74,
    Capacity: 75,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 39,
    Capacity: 80,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 39,
    Capacity: 80,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 40,
    Capacity: 90,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 40,
    Capacity: 90,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 67,
    Capacity: 65,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 87,
    Capacity: 95,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 38,
    Capacity: 30,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 25,
    Capacity: 35,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 25,
    Capacity: 35,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 115,
    Capacity: 120,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 50,
    Capacity: 51,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 50,
    Capacity: 51,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 38,
    Capacity: 30,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 20,
    Capacity: 30,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 140,
    Capacity: 141,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 140,
    Capacity: 141,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 66,
    Capacity: 66,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 93,
    Capacity: 101,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 105,
    Capacity: 155,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 54,
    Capacity: 54,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 78,
    Capacity: 120,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 54,
    Capacity: 54,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 54,
    Capacity: 54,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 20,
    Capacity: 30,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 23,
    Capacity: 40,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Jacobs Hall',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 23,
    Capacity: 40,
    address: '2530 Ridge Road',
    lat: 37.8760227,
    lon: -122.2613956,
    center: [
      37.8760227,
      -122.2613956,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 89,
    Capacity: 93,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 89,
    Capacity: 93,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 100,
    Capacity: 91,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 87,
    Capacity: 91,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 87,
    Capacity: 91,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 75,
    Capacity: 80,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 75,
    Capacity: 80,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 100,
    Capacity: 91,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 100,
    Capacity: 91,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 87,
    Capacity: 91,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 87,
    Capacity: 91,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 75,
    Capacity: 80,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 75,
    Capacity: 80,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 100,
    Capacity: 91,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 74,
    Capacity: 65,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Joan and Sanford I. Weill',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 74,
    Capacity: 65,
    address: 'Frank Schlessinger Way',
    lat: 37.870932,
    lon: -122.2655629,
    center: [
      37.870932,
      -122.2655629,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 607,
    Capacity: 598,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 606,
    Capacity: 610,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 673,
    Capacity: 567,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 679,
    Capacity: 571,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 176,
    Capacity: 200,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 135,
    Capacity: 160,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 216,
    Capacity: 220,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 453,
    Capacity: 462,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 345,
    Capacity: 396,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 357,
    Capacity: 432,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 219,
    Capacity: 209,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 222,
    Capacity: 217,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1074,
    Capacity: 1087,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1100,
    Capacity: 1122,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 916,
    Capacity: 930,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 373,
    Capacity: 372,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 169,
    Capacity: 173,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 275,
    Capacity: 283,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 157,
    Capacity: 161,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 57,
    Capacity: 58,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 193,
    Capacity: 193,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 979,
    Capacity: 988,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 958,
    Capacity: 980,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 949,
    Capacity: 935,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 469,
    Capacity: 437,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 248,
    Capacity: 248,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 642,
    Capacity: 651,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 517,
    Capacity: 521,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 601,
    Capacity: 608,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 517,
    Capacity: 521,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 838,
    Capacity: 850,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 160,
    Capacity: 161,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 730,
    Capacity: 784,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '10:00pm-11:00pm',
    Enrolled: 48,
    Capacity: 52,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 425,
    Capacity: 512,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 259,
    Capacity: 261,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 252,
    Capacity: 243,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1030,
    Capacity: 1032,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1054,
    Capacity: 1062,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 870,
    Capacity: 870,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 348,
    Capacity: 342,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 170,
    Capacity: 173,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 276,
    Capacity: 283,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 150,
    Capacity: 155,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 53,
    Capacity: 52,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 164,
    Capacity: 163,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 895,
    Capacity: 898,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 881,
    Capacity: 919,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 867,
    Capacity: 870,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 359,
    Capacity: 359,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 26,
    Capacity: 26,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 506,
    Capacity: 518,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 713,
    Capacity: 730,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 635,
    Capacity: 694,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 377,
    Capacity: 460,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Latimer',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 163,
    Capacity: 214,
    address: 'University Drive',
    lat: 37.8731064,
    lon: -122.2585664,
    center: [
      37.8731064,
      -122.2585664,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 271,
    Capacity: 270,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 270,
    Capacity: 281,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 262,
    Capacity: 256,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 24,
    Capacity: 25,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 40,
    Capacity: 40,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 40,
    Capacity: 40,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 292,
    Capacity: 322,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 237,
    Capacity: 3,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 246,
    Capacity: 250,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 289,
    Capacity: 320,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 328,
    Capacity: 332,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 150,
    Capacity: 125,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 388,
    Capacity: 365,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 305,
    Capacity: 306,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 206,
    Capacity: 232,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 206,
    Capacity: 232,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 260,
    Capacity: 261,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 689,
    Capacity: 691,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 429,
    Capacity: 430,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 10,
    Capacity: 10,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 328,
    Capacity: 332,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 271,
    Capacity: 270,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 270,
    Capacity: 281,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 262,
    Capacity: 256,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 28,
    Capacity: 30,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 40,
    Capacity: 40,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 40,
    Capacity: 40,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 292,
    Capacity: 322,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 237,
    Capacity: 3,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 246,
    Capacity: 250,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 270,
    Capacity: 290,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 328,
    Capacity: 332,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 150,
    Capacity: 125,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 388,
    Capacity: 365,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 238,
    Capacity: 240,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 206,
    Capacity: 232,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 206,
    Capacity: 232,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 260,
    Capacity: 261,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 689,
    Capacity: 691,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 429,
    Capacity: 430,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 328,
    Capacity: 332,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 271,
    Capacity: 270,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 270,
    Capacity: 281,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 42,
    Capacity: 44,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 292,
    Capacity: 293,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 55,
    Capacity: 60,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 254,
    Capacity: 265,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Lewis',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 285,
    Capacity: 310,
    address: 'Lewis Hall',
    lat: 37.872926,
    lon: -122.2575191,
    center: [
      37.872926,
      -122.2575191,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 35,
    Capacity: 48,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 242,
    Capacity: 232,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 10,
    Capacity: 12,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 10,
    Capacity: 12,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 267,
    Capacity: 263,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 267,
    Capacity: 263,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 251,
    Capacity: 229,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 202,
    Capacity: 228,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 333,
    Capacity: 213,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 161,
    Capacity: 166,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 296,
    Capacity: 296,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 635,
    Capacity: 649,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 339,
    Capacity: 353,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 201,
    Capacity: 180,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 201,
    Capacity: 180,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 206,
    Capacity: 240,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 206,
    Capacity: 240,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 527,
    Capacity: 522,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 688,
    Capacity: 688,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 35,
    Capacity: 48,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 242,
    Capacity: 232,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 10,
    Capacity: 12,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 10,
    Capacity: 12,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 267,
    Capacity: 263,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 267,
    Capacity: 263,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 251,
    Capacity: 229,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 202,
    Capacity: 228,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 333,
    Capacity: 213,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 161,
    Capacity: 166,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 296,
    Capacity: 296,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 635,
    Capacity: 649,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 339,
    Capacity: 353,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 206,
    Capacity: 240,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 206,
    Capacity: 240,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 527,
    Capacity: 522,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 688,
    Capacity: 688,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 232,
    Capacity: 220,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 251,
    Capacity: 229,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'Li Ka Shing',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 152,
    Capacity: 168,
    address: 'Li Ka Shing Center',
    lat: 37.8726214,
    lon: -122.2678549,
    center: [
      37.8726214,
      -122.2678549,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 92,
    Capacity: 101,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 82,
    Capacity: 95,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 81,
    Capacity: 100,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 58,
    Capacity: 65,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 52,
    Capacity: 50,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 36,
    Capacity: 50,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 14,
    Capacity: 16,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 191,
    Capacity: 191,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 176,
    Capacity: 185,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 212,
    Capacity: 242,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 135,
    Capacity: 151,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 116,
    Capacity: 118,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 127,
    Capacity: 133,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 127,
    Capacity: 133,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 102,
    Capacity: 105,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 78,
    Capacity: 85,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 100,
    Capacity: 100,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 241,
    Capacity: 255,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 141,
    Capacity: 155,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 184,
    Capacity: 205,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 300,
    Capacity: 323,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 24,
    Capacity: 35,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 54,
    Capacity: 75,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 53,
    Capacity: 72,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 94,
    Capacity: 115,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 78,
    Capacity: 75,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 23,
    Capacity: 25,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 153,
    Capacity: 150,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 162,
    Capacity: 170,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 209,
    Capacity: 247,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 131,
    Capacity: 150,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 147,
    Capacity: 150,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 102,
    Capacity: 108,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 102,
    Capacity: 108,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 17,
    Capacity: 17,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 117,
    Capacity: 147,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 130,
    Capacity: 130,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 271,
    Capacity: 285,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 141,
    Capacity: 155,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 184,
    Capacity: 190,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 313,
    Capacity: 320,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 141,
    Capacity: 135,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 146,
    Capacity: 145,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 35,
    Capacity: 35,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 35,
    Capacity: 35,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 35,
    Capacity: 35,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 75,
    Capacity: 79,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 143,
    Capacity: 147,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 147,
    Capacity: 151,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McCone',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 122,
    Capacity: 125,
    address: 'McCone Hall',
    lat: 37.8740817,
    lon: -122.2622537,
    center: [
      37.8740817,
      -122.2622537,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 46,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 46,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 51,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 49,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 49,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 41,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 41,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 29,
    Capacity: 35,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 29,
    Capacity: 35,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 48,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 48,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 51,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 47,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 45,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 45,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 46,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 46,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 50,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 50,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 47,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 51,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 49,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 49,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 41,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 41,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 29,
    Capacity: 35,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 29,
    Capacity: 35,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 48,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 48,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 51,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 47,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 45,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 45,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 50,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 50,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'McLaughlin',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 47,
    Capacity: 52,
    address: 'McLaughlin Hall',
    lat: 37.8738011,
    lon: -122.2615698,
    center: [
      37.8738011,
      -122.2615698,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 135,
    Capacity: 144,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 231,
    Capacity: 230,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 112,
    Capacity: 129,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 212,
    Capacity: 225,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 103,
    Capacity: 129,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 69,
    Capacity: 82,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 96,
    Capacity: 96,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 147,
    Capacity: 146,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 101,
    Capacity: 101,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 132,
    Capacity: 144,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 209,
    Capacity: 205,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 100,
    Capacity: 96,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 83,
    Capacity: 84,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 183,
    Capacity: 180,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 183,
    Capacity: 180,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 95,
    Capacity: 115,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 190,
    Capacity: 211,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 120,
    Capacity: 134,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 354,
    Capacity: 364,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 135,
    Capacity: 144,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 199,
    Capacity: 216,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 49,
    Capacity: 70,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 87,
    Capacity: 110,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 117,
    Capacity: 120,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 79,
    Capacity: 80,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 79,
    Capacity: 80,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 96,
    Capacity: 96,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 52,
    Capacity: 50,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 101,
    Capacity: 101,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 35,
    Capacity: 48,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 209,
    Capacity: 205,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 100,
    Capacity: 96,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 100,
    Capacity: 96,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 156,
    Capacity: 180,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 76,
    Capacity: 124,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 20,
    Capacity: 40,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 132,
    Capacity: 152,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 259,
    Capacity: 282,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 120,
    Capacity: 134,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 354,
    Capacity: 364,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 100,
    Capacity: 96,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 150,
    Capacity: 146,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 96,
    Capacity: 96,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 52,
    Capacity: 50,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Moffitt Library',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 101,
    Capacity: 101,
    address: '350 Moffitt Library',
    lat: 37.8725327,
    lon: -122.2634115,
    center: [
      37.8725327,
      -122.2634115,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 135,
    Capacity: 142,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 88,
    Capacity: 70,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 58,
    Capacity: 70,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 18,
    Capacity: 25,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 133,
    Capacity: 130,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 145,
    Capacity: 163,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 146,
    Capacity: 145,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 123,
    Capacity: 120,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 150,
    Capacity: 170,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 158,
    Capacity: 230,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 73,
    Capacity: 125,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 39,
    Capacity: 40,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 166,
    Capacity: 166,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 142,
    Capacity: 142,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 141,
    Capacity: 141,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 264,
    Capacity: 261,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 135,
    Capacity: 142,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 88,
    Capacity: 70,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 58,
    Capacity: 70,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 26,
    Capacity: 25,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 25,
    Capacity: 0,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 133,
    Capacity: 130,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 161,
    Capacity: 178,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 119,
    Capacity: 120,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 74,
    Capacity: 65,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 147,
    Capacity: 143,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 110,
    Capacity: 130,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 158,
    Capacity: 230,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 48,
    Capacity: 100,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 23,
    Capacity: 24,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 142,
    Capacity: 142,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 142,
    Capacity: 142,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 141,
    Capacity: 141,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 298,
    Capacity: 301,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 135,
    Capacity: 142,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 88,
    Capacity: 70,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 58,
    Capacity: 70,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 133,
    Capacity: 130,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morgan',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 121,
    Capacity: 138,
    address: 'Morgan Hall',
    lat: 37.8733142,
    lon: -122.2667813,
    center: [
      37.8733142,
      -122.2667813,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 129,
    Capacity: 150,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 140,
    Capacity: 164,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 140,
    Capacity: 164,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 39,
    Capacity: 35,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 20,
    Capacity: 20,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 48,
    Capacity: 60,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 48,
    Capacity: 60,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 33,
    Capacity: 42,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 57,
    Capacity: 72,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 152,
    Capacity: 156,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 83,
    Capacity: 85,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 176,
    Capacity: 182,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 87,
    Capacity: 104,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 110,
    Capacity: 139,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 23,
    Capacity: 35,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 35,
    Capacity: 35,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 21,
    Capacity: 35,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 21,
    Capacity: 35,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 101,
    Capacity: 102,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 117,
    Capacity: 122,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 160,
    Capacity: 165,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 320,
    Capacity: 327,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 129,
    Capacity: 150,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 104,
    Capacity: 125,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 121,
    Capacity: 149,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 68,
    Capacity: 100,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 58,
    Capacity: 60,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 83,
    Capacity: 100,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 65,
    Capacity: 80,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 33,
    Capacity: 42,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 5,
    Capacity: 30,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 77,
    Capacity: 92,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 172,
    Capacity: 176,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 83,
    Capacity: 85,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 157,
    Capacity: 162,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 87,
    Capacity: 104,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 100,
    Capacity: 124,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 13,
    Capacity: 20,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 20,
    Capacity: 24,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 101,
    Capacity: 102,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 101,
    Capacity: 102,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 144,
    Capacity: 145,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 301,
    Capacity: 307,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 46,
    Capacity: 65,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 50,
    Capacity: 55,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 73,
    Capacity: 84,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Morrison',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 152,
    Capacity: 156,
    address: 'Morrison Hall',
    lat: 37.8708467,
    lon: -122.2590721,
    center: [
      37.8708467,
      -122.2590721,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 226,
    Capacity: 228,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 160,
    Capacity: 161,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 202,
    Capacity: 212,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 117,
    Capacity: 117,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 51,
    Capacity: 60,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 51,
    Capacity: 60,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 101,
    Capacity: 95,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 209,
    Capacity: 208,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 281,
    Capacity: 275,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 234,
    Capacity: 228,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 288,
    Capacity: 287,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 279,
    Capacity: 284,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 287,
    Capacity: 288,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 153,
    Capacity: 146,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 164,
    Capacity: 160,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 132,
    Capacity: 130,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 201,
    Capacity: 152,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 201,
    Capacity: 152,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 230,
    Capacity: 199,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 413,
    Capacity: 382,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 207,
    Capacity: 209,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 203,
    Capacity: 206,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 187,
    Capacity: 190,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 140,
    Capacity: 140,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 51,
    Capacity: 60,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 51,
    Capacity: 60,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 101,
    Capacity: 95,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 209,
    Capacity: 208,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 185,
    Capacity: 180,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 184,
    Capacity: 178,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 288,
    Capacity: 287,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 252,
    Capacity: 259,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 265,
    Capacity: 268,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 94,
    Capacity: 89,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 97,
    Capacity: 90,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 138,
    Capacity: 130,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 41,
    Capacity: 40,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 201,
    Capacity: 152,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 201,
    Capacity: 152,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 230,
    Capacity: 199,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 413,
    Capacity: 382,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 226,
    Capacity: 253,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 160,
    Capacity: 161,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 30,
    Capacity: 31,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 117,
    Capacity: 117,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 106,
    Capacity: 100,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 47,
    Capacity: 47,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 185,
    Capacity: 180,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'Mulford',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 224,
    Capacity: 243,
    address: 'Mulford Hall',
    lat: 37.8726096,
    lon: -122.267056,
    center: [
      37.8726096,
      -122.267056,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 120,
    Capacity: 130,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 121,
    Capacity: 120,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 121,
    Capacity: 120,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 83,
    Capacity: 100,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 127,
    Capacity: 130,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 49,
    Capacity: 50,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 49,
    Capacity: 50,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 57,
    Capacity: 100,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 138,
    Capacity: 138,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 150,
    Capacity: 150,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 176,
    Capacity: 210,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 26,
    Capacity: 60,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 99,
    Capacity: 100,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 159,
    Capacity: 154,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 60,
    Capacity: 54,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 122,
    Capacity: 123,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 260,
    Capacity: 261,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 120,
    Capacity: 130,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 33,
    Capacity: 30,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 33,
    Capacity: 30,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 33,
    Capacity: 30,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 83,
    Capacity: 100,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 127,
    Capacity: 130,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 49,
    Capacity: 50,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 49,
    Capacity: 50,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 57,
    Capacity: 100,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 138,
    Capacity: 138,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 150,
    Capacity: 150,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 176,
    Capacity: 210,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 26,
    Capacity: 60,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 60,
    Capacity: 54,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 60,
    Capacity: 54,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 122,
    Capacity: 123,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 260,
    Capacity: 261,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 120,
    Capacity: 130,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 127,
    Capacity: 130,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 90,
    Capacity: 95,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: 'North Gate',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 57,
    Capacity: 100,
    address: 'North Gate Hall',
    lat: 37.8749998,
    lon: -122.2622433,
    center: [
      37.8749998,
      -122.2622433,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 16,
    Capacity: 22,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 37,
    Capacity: 46,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 41,
    Capacity: 50,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 41,
    Capacity: 50,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 20,
    Capacity: 65,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 31,
    Capacity: 40,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 24,
    Capacity: 45,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 24,
    Capacity: 45,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 39,
    Capacity: 46,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 16,
    Capacity: 22,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 48,
    Capacity: 49,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 49,
    Capacity: 50,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 44,
    Capacity: 46,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 41,
    Capacity: 50,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 41,
    Capacity: 50,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 20,
    Capacity: 65,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 31,
    Capacity: 40,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 24,
    Capacity: 45,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 24,
    Capacity: 45,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 11,
    Capacity: 24,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 31,
    Capacity: 40,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: "O'Brien",
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 31,
    Capacity: 40,
    address: "O'Brien Hall",
    lat: 37.8742817,
    lon: -122.2616369,
    center: [
      37.8742817,
      -122.2616369,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 205,
    Capacity: 236,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 374,
    Capacity: 461,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 633,
    Capacity: 638,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 394,
    Capacity: 398,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 170,
    Capacity: 187,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 321,
    Capacity: 343,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 216,
    Capacity: 232,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 24,
    Capacity: 24,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 445,
    Capacity: 479,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 384,
    Capacity: 387,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 641,
    Capacity: 671,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 140,
    Capacity: 140,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 204,
    Capacity: 248,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 626,
    Capacity: 633,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1119,
    Capacity: 1152,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 608,
    Capacity: 642,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 597,
    Capacity: 548,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 658,
    Capacity: 675,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 149,
    Capacity: 225,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 107,
    Capacity: 118,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 564,
    Capacity: 443,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 530,
    Capacity: 399,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 472,
    Capacity: 510,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 653,
    Capacity: 741,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 229,
    Capacity: 260,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 416,
    Capacity: 532,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 675,
    Capacity: 709,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 581,
    Capacity: 607,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 379,
    Capacity: 397,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 530,
    Capacity: 553,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 216,
    Capacity: 232,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 48,
    Capacity: 48,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 523,
    Capacity: 627,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 408,
    Capacity: 411,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 665,
    Capacity: 695,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 86,
    Capacity: 86,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 262,
    Capacity: 315,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 621,
    Capacity: 633,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 930,
    Capacity: 941,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 353,
    Capacity: 356,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 556,
    Capacity: 498,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 658,
    Capacity: 675,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 149,
    Capacity: 225,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 130,
    Capacity: 142,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 612,
    Capacity: 492,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 553,
    Capacity: 423,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 472,
    Capacity: 510,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 682,
    Capacity: 759,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 157,
    Capacity: 188,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 58,
    Capacity: 140,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 341,
    Capacity: 342,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 150,
    Capacity: 150,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 150,
    Capacity: 150,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 419,
    Capacity: 453,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 117,
    Capacity: 119,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 277,
    Capacity: 304,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Physics Building',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 14,
    Capacity: 14,
    address: 'Physics Building',
    lat: 37.8724754,
    lon: -122.2616949,
    center: [
      37.8724754,
      -122.2616949,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 446,
    Capacity: 447,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 262,
    Capacity: 264,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 357,
    Capacity: 360,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 351,
    Capacity: 354,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 724,
    Capacity: 724,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 1202,
    Capacity: 1224,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 478,
    Capacity: 500,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 687,
    Capacity: 687,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 450,
    Capacity: 451,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 509,
    Capacity: 510,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 454,
    Capacity: 455,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 244,
    Capacity: 252,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 202,
    Capacity: 240,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 369,
    Capacity: 369,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 655,
    Capacity: 655,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 286,
    Capacity: 286,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 654,
    Capacity: 690,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 1049,
    Capacity: 1090,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 395,
    Capacity: 400,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 304,
    Capacity: 304,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 708,
    Capacity: 712,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 404,
    Capacity: 408,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 358,
    Capacity: 360,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 560,
    Capacity: 600,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 446,
    Capacity: 447,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 262,
    Capacity: 264,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 357,
    Capacity: 360,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 348,
    Capacity: 349,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 300,
    Capacity: 301,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 478,
    Capacity: 500,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 478,
    Capacity: 500,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 687,
    Capacity: 687,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 450,
    Capacity: 451,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 509,
    Capacity: 510,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 454,
    Capacity: 455,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 244,
    Capacity: 252,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 202,
    Capacity: 240,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 369,
    Capacity: 369,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 655,
    Capacity: 655,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 286,
    Capacity: 286,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 654,
    Capacity: 690,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 1049,
    Capacity: 1090,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 395,
    Capacity: 400,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 304,
    Capacity: 304,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 708,
    Capacity: 712,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 404,
    Capacity: 408,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 358,
    Capacity: 360,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 560,
    Capacity: 600,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 446,
    Capacity: 447,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 262,
    Capacity: 264,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 357,
    Capacity: 360,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 264,
    Capacity: 272,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 687,
    Capacity: 687,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 450,
    Capacity: 451,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 343,
    Capacity: 346,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 454,
    Capacity: 455,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'Pimentel',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 244,
    Capacity: 252,
    address: 'University Drive',
    lat: 37.8734123,
    lon: -122.2585925,
    center: [
      37.8734123,
      -122.2585925,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 27,
    Capacity: 30,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 31,
    Capacity: 30,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 25,
    Capacity: 35,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 35,
    Capacity: 35,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 39,
    Capacity: 42,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 25,
    Capacity: 30,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 25,
    Capacity: 30,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 39,
    Capacity: 42,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 27,
    Capacity: 30,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 31,
    Capacity: 30,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 25,
    Capacity: 35,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 35,
    Capacity: 35,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 46,
    Capacity: 42,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 34,
    Capacity: 30,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 34,
    Capacity: 30,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'RSF Fieldhouse',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 46,
    Capacity: 42,
    address: '2301 Bancroft Way Room 145',
    lat: 37.8684483,
    lon: -122.2673405,
    center: [
      37.8684483,
      -122.2673405,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 37,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 40,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 40,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 47,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 47,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 37,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 37,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 40,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 40,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 47,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 47,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Rec Sports Facility',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 37,
    Capacity: 44,
    address: '2301 Bancroft Way',
    lat: 37.8685917,
    lon: -122.2653688,
    center: [
      37.8685917,
      -122.2653688,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 524,
    Capacity: 551,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 341,
    Capacity: 377,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 284,
    Capacity: 321,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 531,
    Capacity: 567,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 366,
    Capacity: 419,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 308,
    Capacity: 384,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 210,
    Capacity: 240,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 143,
    Capacity: 145,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 203,
    Capacity: 217,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 536,
    Capacity: 591,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 662,
    Capacity: 729,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 378,
    Capacity: 406,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 688,
    Capacity: 714,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 640,
    Capacity: 708,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 893,
    Capacity: 960,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 528,
    Capacity: 546,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 362,
    Capacity: 364,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 386,
    Capacity: 395,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 112,
    Capacity: 122,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 185,
    Capacity: 235,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 871,
    Capacity: 954,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 749,
    Capacity: 790,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 785,
    Capacity: 869,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1184,
    Capacity: 1263,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 417,
    Capacity: 434,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 497,
    Capacity: 505,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 413,
    Capacity: 449,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 507,
    Capacity: 540,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 283,
    Capacity: 355,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 222,
    Capacity: 250,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 91,
    Capacity: 77,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 52,
    Capacity: 53,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 17,
    Capacity: 17,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 340,
    Capacity: 355,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 492,
    Capacity: 585,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 567,
    Capacity: 665,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 248,
    Capacity: 272,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 732,
    Capacity: 758,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 697,
    Capacity: 739,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 890,
    Capacity: 936,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 501,
    Capacity: 523,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 418,
    Capacity: 433,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 374,
    Capacity: 421,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 98,
    Capacity: 135,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 187,
    Capacity: 237,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 18,
    Capacity: 30,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 848,
    Capacity: 914,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 764,
    Capacity: 804,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 678,
    Capacity: 754,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1159,
    Capacity: 1235,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 365,
    Capacity: 388,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 261,
    Capacity: 294,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 161,
    Capacity: 169,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 72,
    Capacity: 80,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 55,
    Capacity: 63,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 90,
    Capacity: 97,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 356,
    Capacity: 374,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 427,
    Capacity: 452,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 484,
    Capacity: 585,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Social Sciences Building',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 326,
    Capacity: 391,
    address: 'Social Sciences Building',
    lat: 37.8700546,
    lon: -122.2605649,
    center: [
      37.8700546,
      -122.2605649,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 194,
    Capacity: 221,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 194,
    Capacity: 221,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 10,
    Capacity: 30,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 10,
    Capacity: 30,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 356,
    Capacity: 360,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 371,
    Capacity: 380,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 49,
    Capacity: 48,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 60,
    Capacity: 69,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 60,
    Capacity: 69,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 79,
    Capacity: 86,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 79,
    Capacity: 86,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 49,
    Capacity: 48,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 183,
    Capacity: 198,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 183,
    Capacity: 198,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 16,
    Capacity: 30,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 16,
    Capacity: 30,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 356,
    Capacity: 360,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 371,
    Capacity: 380,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 49,
    Capacity: 48,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 46,
    Capacity: 54,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 57,
    Capacity: 71,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 11,
    Capacity: 17,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 79,
    Capacity: 86,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 79,
    Capacity: 86,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 49,
    Capacity: 48,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Friday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 14,
    Capacity: 30,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Friday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 14,
    Capacity: 30,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'Soda',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 15,
    Capacity: 20,
    address: 'Soda Hall',
    lat: 37.8755939,
    lon: -122.2613614,
    center: [
      37.8755939,
      -122.2613614,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 15,
    Capacity: 15,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 46,
    Capacity: 49,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 46,
    Capacity: 49,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 46,
    Capacity: 49,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 46,
    Capacity: 49,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 47,
    Capacity: 49,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 14,
    Capacity: 15,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 14,
    Capacity: 15,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'South Hall',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 47,
    Capacity: 49,
    address: 'South Hall',
    lat: 37.8712935,
    lon: -122.261083,
    center: [
      37.8712935,
      -122.261083,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 239,
    Capacity: 236,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 294,
    Capacity: 355,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 322,
    Capacity: 370,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 315,
    Capacity: 351,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 434,
    Capacity: 431,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 375,
    Capacity: 374,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 206,
    Capacity: 280,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 261,
    Capacity: 240,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 432,
    Capacity: 436,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 338,
    Capacity: 345,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 588,
    Capacity: 595,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 305,
    Capacity: 305,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 150,
    Capacity: 150,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 201,
    Capacity: 213,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 470,
    Capacity: 518,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 312,
    Capacity: 354,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 379,
    Capacity: 401,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 758,
    Capacity: 793,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 319,
    Capacity: 375,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 269,
    Capacity: 365,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 248,
    Capacity: 268,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 256,
    Capacity: 332,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 315,
    Capacity: 351,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 440,
    Capacity: 436,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 401,
    Capacity: 409,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 185,
    Capacity: 260,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 329,
    Capacity: 309,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 431,
    Capacity: 436,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 338,
    Capacity: 345,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 558,
    Capacity: 565,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 280,
    Capacity: 280,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 30,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 201,
    Capacity: 213,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 470,
    Capacity: 518,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 335,
    Capacity: 375,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 383,
    Capacity: 427,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 767,
    Capacity: 788,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 210,
    Capacity: 206,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 201,
    Capacity: 235,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 227,
    Capacity: 250,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 35,
    Capacity: 10,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 35,
    Capacity: 10,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 285,
    Capacity: 321,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 435,
    Capacity: 431,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 355,
    Capacity: 354,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 158,
    Capacity: 230,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stanley',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 260,
    Capacity: 259,
    address: 'University Drive',
    lat: 37.873851,
    lon: -122.2589733,
    center: [
      37.873851,
      -122.2589733,
    ],
  },
  {
    Location: 'Stephens',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 14,
    Capacity: 18,
    address: 'Stephens Hall',
    lat: 37.8714622,
    lon: -122.2600936,
    center: [
      37.8714622,
      -122.2600936,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Sutardja Dai',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 89,
    Capacity: 91,
    address: '2594 Hearst Avenue',
    lat: 37.8750267,
    lon: -122.2608888,
    center: [
      37.8750267,
      -122.2608888,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 59,
    Capacity: 75,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 61,
    Capacity: 38,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 61,
    Capacity: 38,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 61,
    Capacity: 38,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 65,
    Capacity: 66,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 25,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 25,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 25,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 51,
    Capacity: 54,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 51,
    Capacity: 54,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 49,
    Capacity: 60,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 49,
    Capacity: 60,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 59,
    Capacity: 75,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 32,
    Capacity: 50,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 65,
    Capacity: 66,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 46,
    Capacity: 40,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 23,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 23,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 23,
    Capacity: 30,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 51,
    Capacity: 54,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 51,
    Capacity: 54,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 49,
    Capacity: 60,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 49,
    Capacity: 60,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 59,
    Capacity: 75,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 65,
    Capacity: 66,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 69,
    Capacity: 3,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Tan',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 69,
    Capacity: 3,
    address: 'University Drive',
    lat: 37.8732811,
    lon: -122.2590869,
    center: [
      37.8732811,
      -122.2590869,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 965,
    Capacity: 943,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1022,
    Capacity: 1037,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 681,
    Capacity: 705,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 482,
    Capacity: 469,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 443,
    Capacity: 77,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 211,
    Capacity: 218,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 176,
    Capacity: 176,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 692,
    Capacity: 692,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 176,
    Capacity: 176,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1182,
    Capacity: 1141,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 26,
    Capacity: 26,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 859,
    Capacity: 873,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 670,
    Capacity: 724,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 860,
    Capacity: 800,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 733,
    Capacity: 751,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1308,
    Capacity: 1332,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1950,
    Capacity: 1947,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 1011,
    Capacity: 1020,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 587,
    Capacity: 591,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 839,
    Capacity: 846,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 230,
    Capacity: 233,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 399,
    Capacity: 400,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 84,
    Capacity: 83,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1267,
    Capacity: 1247,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '09:00pm-10:00pm',
    Enrolled: 84,
    Capacity: 83,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 881,
    Capacity: 889,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 927,
    Capacity: 949,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1429,
    Capacity: 1458,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 723,
    Capacity: 740,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1048,
    Capacity: 1071,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 973,
    Capacity: 1063,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 401,
    Capacity: 433,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 708,
    Capacity: 387,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 249,
    Capacity: 289,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 224,
    Capacity: 273,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 723,
    Capacity: 722,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 176,
    Capacity: 218,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1017,
    Capacity: 1022,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 725,
    Capacity: 736,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 780,
    Capacity: 832,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 521,
    Capacity: 528,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 776,
    Capacity: 796,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1320,
    Capacity: 1309,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 2023,
    Capacity: 1989,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 977,
    Capacity: 980,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 541,
    Capacity: 550,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 541,
    Capacity: 550,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 359,
    Capacity: 360,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1165,
    Capacity: 1169,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 865,
    Capacity: 868,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 924,
    Capacity: 964,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1429,
    Capacity: 1484,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 441,
    Capacity: 438,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 744,
    Capacity: 748,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 796,
    Capacity: 816,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 601,
    Capacity: 613,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 85,
    Capacity: 102,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 85,
    Capacity: 102,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 734,
    Capacity: 732,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 960,
    Capacity: 960,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 535,
    Capacity: 544,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 787,
    Capacity: 822,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Valley Life Sciences',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 458,
    Capacity: 423,
    address: 'Valley Life Sciences Building',
    lat: 37.8714896,
    lon: -122.2647157,
    center: [
      37.8714896,
      -122.2647157,
    ],
  },
  {
    Location: 'Wellman',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 36,
    Capacity: 35,
    address: 'Wickson Loop',
    lat: 37.873023,
    lon: -122.2653599,
    center: [
      37.873023,
      -122.2653599,
    ],
  },
  {
    Location: 'Wellman',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 35,
    Capacity: 35,
    address: 'Wickson Loop',
    lat: 37.873023,
    lon: -122.2653599,
    center: [
      37.873023,
      -122.2653599,
    ],
  },
  {
    Location: 'Wellman',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 36,
    Capacity: 35,
    address: 'Wickson Loop',
    lat: 37.873023,
    lon: -122.2653599,
    center: [
      37.873023,
      -122.2653599,
    ],
  },
  {
    Location: 'Wellman',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 35,
    Capacity: 35,
    address: 'Wickson Loop',
    lat: 37.873023,
    lon: -122.2653599,
    center: [
      37.873023,
      -122.2653599,
    ],
  },
  {
    Location: 'Wellman',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 14,
    Capacity: 20,
    address: 'Wickson Loop',
    lat: 37.873023,
    lon: -122.2653599,
    center: [
      37.873023,
      -122.2653599,
    ],
  },
  {
    Location: 'Wellman',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 35,
    Capacity: 35,
    address: 'Wickson Loop',
    lat: 37.873023,
    lon: -122.2653599,
    center: [
      37.873023,
      -122.2653599,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1648,
    Capacity: 1792,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1468,
    Capacity: 1546,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1608,
    Capacity: 1743,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 1005,
    Capacity: 734,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 895,
    Capacity: 906,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 820,
    Capacity: 860,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 714,
    Capacity: 773,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 508,
    Capacity: 556,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 21,
    Capacity: 29,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1009,
    Capacity: 998,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1928,
    Capacity: 1866,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1229,
    Capacity: 1338,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1144,
    Capacity: 1182,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1338,
    Capacity: 1408,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1199,
    Capacity: 1198,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1955,
    Capacity: 1999,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 821,
    Capacity: 861,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 725,
    Capacity: 803,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 987,
    Capacity: 1107,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 299,
    Capacity: 369,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 628,
    Capacity: 766,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 90,
    Capacity: 99,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1372,
    Capacity: 1479,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 861,
    Capacity: 908,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1674,
    Capacity: 1525,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 2789,
    Capacity: 2671,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1638,
    Capacity: 1832,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1243,
    Capacity: 1303,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1222,
    Capacity: 1347,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 950,
    Capacity: 1194,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 963,
    Capacity: 968,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 835,
    Capacity: 888,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 752,
    Capacity: 849,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 604,
    Capacity: 672,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 999,
    Capacity: 1010,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1825,
    Capacity: 1777,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1173,
    Capacity: 1262,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 1146,
    Capacity: 1178,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1294,
    Capacity: 1352,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1227,
    Capacity: 1228,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 1927,
    Capacity: 1972,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 845,
    Capacity: 878,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 692,
    Capacity: 754,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 805,
    Capacity: 922,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 188,
    Capacity: 267,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 659,
    Capacity: 802,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 39,
    Capacity: 40,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 1311,
    Capacity: 1425,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 763,
    Capacity: 806,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1665,
    Capacity: 1512,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 2674,
    Capacity: 2542,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 1571,
    Capacity: 1846,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 1080,
    Capacity: 1159,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 969,
    Capacity: 1122,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 544,
    Capacity: 285,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 24,
    Capacity: 25,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 24,
    Capacity: 25,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '08:00am-09:00am',
    Enrolled: 534,
    Capacity: 582,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 882,
    Capacity: 879,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 1785,
    Capacity: 1742,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 1081,
    Capacity: 1166,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wheeler',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 998,
    Capacity: 1172,
    address: 'Wheeler Hall',
    lat: 37.8713074,
    lon: -122.2617242,
    center: [
      37.8713074,
      -122.2617242,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 132,
    Capacity: 130,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 339,
    Capacity: 345,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 241,
    Capacity: 358,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 144,
    Capacity: 247,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 131,
    Capacity: 233,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 73,
    Capacity: 88,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 73,
    Capacity: 88,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 45,
    Capacity: 60,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 139,
    Capacity: 184,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 96,
    Capacity: 242,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 52,
    Capacity: 144,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 169,
    Capacity: 258,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 106,
    Capacity: 122,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 193,
    Capacity: 220,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 347,
    Capacity: 411,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 246,
    Capacity: 286,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 168,
    Capacity: 178,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 160,
    Capacity: 168,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 39,
    Capacity: 38,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 342,
    Capacity: 359,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 348,
    Capacity: 359,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 208,
    Capacity: 228,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 254,
    Capacity: 276,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 134,
    Capacity: 136,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 352,
    Capacity: 359,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 241,
    Capacity: 358,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 131,
    Capacity: 233,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 131,
    Capacity: 233,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 10,
    Capacity: 13,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 26,
    Capacity: 73,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '08:00pm-09:00pm',
    Enrolled: 16,
    Capacity: 60,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 148,
    Capacity: 200,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 105,
    Capacity: 258,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 61,
    Capacity: 160,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 171,
    Capacity: 264,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 93,
    Capacity: 98,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 168,
    Capacity: 200,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 311,
    Capacity: 363,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 195,
    Capacity: 218,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '05:00pm-06:00pm',
    Enrolled: 167,
    Capacity: 167,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '06:00pm-07:00pm',
    Enrolled: 236,
    Capacity: 240,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '07:00pm-08:00pm',
    Enrolled: 107,
    Capacity: 112,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 348,
    Capacity: 350,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 354,
    Capacity: 355,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 214,
    Capacity: 228,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 228,
    Capacity: 241,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 163,
    Capacity: 186,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 193,
    Capacity: 201,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 160,
    Capacity: 200,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 109,
    Capacity: 130,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 84,
    Capacity: 119,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 185,
    Capacity: 270,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 215,
    Capacity: 260,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Wurster',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 206,
    Capacity: 250,
    address: 'Wurster Hall',
    lat: 37.8707352,
    lon: -122.2574684,
    center: [
      37.8707352,
      -122.2574684,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Monday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 43,
    Capacity: 40,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Monday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 48,
    Capacity: 42,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Monday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 48,
    Capacity: 42,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Monday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 12,
    Capacity: 12,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Monday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 37,
    Capacity: 34,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Monday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 37,
    Capacity: 34,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Monday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 43,
    Capacity: 40,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 15,
    Capacity: 14,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 21,
    Capacity: 22,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 21,
    Capacity: 22,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 5,
    Capacity: 6,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 16,
    Capacity: 16,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 29,
    Capacity: 31,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 46,
    Capacity: 55,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 61,
    Capacity: 69,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 43,
    Capacity: 40,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 54,
    Capacity: 48,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 54,
    Capacity: 48,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 18,
    Capacity: 18,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 37,
    Capacity: 34,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 37,
    Capacity: 34,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Wednesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 43,
    Capacity: 40,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 15,
    Capacity: 14,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 21,
    Capacity: 22,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 21,
    Capacity: 22,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 5,
    Capacity: 6,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 16,
    Capacity: 16,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 16,
    Capacity: 16,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 46,
    Capacity: 55,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 61,
    Capacity: 69,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Friday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 43,
    Capacity: 40,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Friday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 42,
    Capacity: 36,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Friday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 42,
    Capacity: 36,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Friday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 6,
    Capacity: 6,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 37,
    Capacity: 34,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 37,
    Capacity: 34,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Zellerbach',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 43,
    Capacity: 40,
    address: '2413 Bancroft Way',
    lat: 37.8690529,
    lon: -122.2613629,
    center: [
      37.8690529,
      -122.2613629,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 45,
    Capacity: 45,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 45,
    Capacity: 45,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 92,
    Capacity: 92,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 47,
    Capacity: 47,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 43,
    Capacity: 45,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 88,
    Capacity: 90,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Wednesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 19,
    Capacity: 25,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Wednesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 19,
    Capacity: 25,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Thursday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 45,
    Capacity: 45,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Thursday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 45,
    Capacity: 45,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Thursday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 92,
    Capacity: 92,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Thursday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 47,
    Capacity: 47,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 43,
    Capacity: 45,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Archaeological Research Facility',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 88,
    Capacity: 90,
    address: '2251 College Avenue',
    lat: 37.8702033,
    lon: -122.2564156,
    center: [
      37.8702033,
      -122.2564156,
    ],
  },
  {
    Location: 'Berkeley Art Museum',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 156,
    Capacity: 157,
    address: '2155 Center Street',
    lat: 37.8707356,
    lon: -122.269059,
    center: [
      37.8707356,
      -122.269059,
    ],
  },
  {
    Location: 'Berkeley Art Museum',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 156,
    Capacity: 157,
    address: '2155 Center Street',
    lat: 37.8707356,
    lon: -122.269059,
    center: [
      37.8707356,
      -122.269059,
    ],
  },
  {
    Location: 'Berkeley Art Museum',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 156,
    Capacity: 150,
    address: '2155 Center Street',
    lat: 37.8707356,
    lon: -122.269059,
    center: [
      37.8707356,
      -122.269059,
    ],
  },
  {
    Location: 'Berkeley Art Museum',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 156,
    Capacity: 150,
    address: '2155 Center Street',
    lat: 37.8707356,
    lon: -122.269059,
    center: [
      37.8707356,
      -122.269059,
    ],
  },
  {
    Location: 'Berkeley Art Museum',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 156,
    Capacity: 157,
    address: '2155 Center Street',
    lat: 37.8707356,
    lon: -122.269059,
    center: [
      37.8707356,
      -122.269059,
    ],
  },
  {
    Location: 'Berkeley Art Museum',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 156,
    Capacity: 157,
    address: '2155 Center Street',
    lat: 37.8707356,
    lon: -122.269059,
    center: [
      37.8707356,
      -122.269059,
    ],
  },
  {
    Location: 'Hargrove',
    Day: 'Tuesday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 17,
    Capacity: 15,
    address: 'Optometry Lane',
    lat: 37.8704442,
    lon: -122.2587614,
    center: [
      37.8704442,
      -122.2587614,
    ],
  },
  {
    Location: 'Hargrove',
    Day: 'Tuesday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 17,
    Capacity: 15,
    address: 'Optometry Lane',
    lat: 37.8704442,
    lon: -122.2587614,
    center: [
      37.8704442,
      -122.2587614,
    ],
  },
  {
    Location: 'Hargrove',
    Day: 'Thursday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 17,
    Capacity: 15,
    address: 'Optometry Lane',
    lat: 37.8704442,
    lon: -122.2587614,
    center: [
      37.8704442,
      -122.2587614,
    ],
  },
  {
    Location: 'Hargrove',
    Day: 'Thursday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 17,
    Capacity: 15,
    address: 'Optometry Lane',
    lat: 37.8704442,
    lon: -122.2587614,
    center: [
      37.8704442,
      -122.2587614,
    ],
  },
  {
    Location: 'Hearst Gym North Field',
    Day: 'Tuesday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 24,
    Capacity: 24,
    address: '400 Eshleman Rd',
    lat: 37.8702735,
    lon: -122.2594964,
    center: [
      37.8702735,
      -122.2594964,
    ],
  },
  {
    Location: 'Hearst Gym North Field',
    Day: 'Tuesday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 24,
    Capacity: 24,
    address: '400 Eshleman Rd',
    lat: 37.8702735,
    lon: -122.2594964,
    center: [
      37.8702735,
      -122.2594964,
    ],
  },
  {
    Location: 'Hearst Gym North Field',
    Day: 'Thursday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 24,
    Capacity: 24,
    address: '400 Eshleman Rd',
    lat: 37.8702735,
    lon: -122.2594964,
    center: [
      37.8702735,
      -122.2594964,
    ],
  },
  {
    Location: 'Hearst Gym North Field',
    Day: 'Thursday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 24,
    Capacity: 24,
    address: '400 Eshleman Rd',
    lat: 37.8702735,
    lon: -122.2594964,
    center: [
      37.8702735,
      -122.2594964,
    ],
  },
  {
    Location: 'McEnerney',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 27,
    Capacity: 28,
    address: '1750 Arch Street',
    lat: 37.8766617,
    lon: -122.2670553,
    center: [
      37.8766617,
      -122.2670553,
    ],
  },
  {
    Location: 'McEnerney',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 27,
    Capacity: 28,
    address: '1750 Arch Street',
    lat: 37.8766617,
    lon: -122.2670553,
    center: [
      37.8766617,
      -122.2670553,
    ],
  },
  {
    Location: 'McEnerney',
    Day: 'Tuesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 27,
    Capacity: 28,
    address: '1750 Arch Street',
    lat: 37.8766617,
    lon: -122.2670553,
    center: [
      37.8766617,
      -122.2670553,
    ],
  },
  {
    Location: 'McEnerney',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 8,
    Capacity: 10,
    address: '1750 Arch Street',
    lat: 37.8766617,
    lon: -122.2670553,
    center: [
      37.8766617,
      -122.2670553,
    ],
  },
  {
    Location: 'McEnerney',
    Day: 'Friday',
    TimeBlock: '11:00am-12:00pm',
    Enrolled: 8,
    Capacity: 10,
    address: '1750 Arch Street',
    lat: 37.8766617,
    lon: -122.2670553,
    center: [
      37.8766617,
      -122.2670553,
    ],
  },
  {
    Location: 'McEnerney',
    Day: 'Friday',
    TimeBlock: '12:00pm-01:00pm',
    Enrolled: 8,
    Capacity: 10,
    address: '1750 Arch Street',
    lat: 37.8766617,
    lon: -122.2670553,
    center: [
      37.8766617,
      -122.2670553,
    ],
  },
  {
    Location: 'School of Public Health, Education, Psychology',
    Day: 'Tuesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 17,
    Capacity: 0,
    address: '2121 Berkeley Way',
    lat: 37.873391,
    lon: -122.2709754,
    center: [
      37.873391,
      -122.2709754,
    ],
  },
  {
    Location: 'School of Public Health, Education, Psychology',
    Day: 'Tuesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 17,
    Capacity: 0,
    address: '2121 Berkeley Way',
    lat: 37.873391,
    lon: -122.2709754,
    center: [
      37.873391,
      -122.2709754,
    ],
  },
  {
    Location: 'School of Public Health, Education, Psychology',
    Day: 'Tuesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 17,
    Capacity: 0,
    address: '2121 Berkeley Way',
    lat: 37.873391,
    lon: -122.2709754,
    center: [
      37.873391,
      -122.2709754,
    ],
  },
  {
    Location: 'Bancroft Library',
    Day: 'Wednesday',
    TimeBlock: '01:00pm-02:00pm',
    Enrolled: 10,
    Capacity: 10,
    address: 'The Bancroft Library',
    lat: 37.8723046,
    lon: -122.2612252,
    center: [
      37.8723046,
      -122.2612252,
    ],
  },
  {
    Location: 'Bancroft Library',
    Day: 'Wednesday',
    TimeBlock: '02:00pm-03:00pm',
    Enrolled: 10,
    Capacity: 10,
    address: 'The Bancroft Library',
    lat: 37.8723046,
    lon: -122.2612252,
    center: [
      37.8723046,
      -122.2612252,
    ],
  },
  {
    Location: 'Bancroft Library',
    Day: 'Wednesday',
    TimeBlock: '03:00pm-04:00pm',
    Enrolled: 10,
    Capacity: 10,
    address: 'The Bancroft Library',
    lat: 37.8723046,
    lon: -122.2612252,
    center: [
      37.8723046,
      -122.2612252,
    ],
  },
  {
    Location: 'Bancroft Library',
    Day: 'Wednesday',
    TimeBlock: '04:00pm-05:00pm',
    Enrolled: 10,
    Capacity: 10,
    address: 'The Bancroft Library',
    lat: 37.8723046,
    lon: -122.2612252,
    center: [
      37.8723046,
      -122.2612252,
    ],
  },
  {
    Location: '2547 Bowditch',
    Day: 'Friday',
    TimeBlock: '09:00am-10:00am',
    Enrolled: 12,
    Capacity: 12,
    address: '2547 Bowditch Street',
    lat: 37.8658566,
    lon: -122.2586439,
    center: [
      37.8658566,
      -122.2586439,
    ],
  },
  {
    Location: '2547 Bowditch',
    Day: 'Friday',
    TimeBlock: '10:00am-11:00am',
    Enrolled: 12,
    Capacity: 12,
    address: '2547 Bowditch Street',
    lat: 37.8658566,
    lon: -122.2586439,
    center: [
      37.8658566,
      -122.2586439,
    ],
  },
];

export default classMapData;
